import { useHistory } from "react-router-dom";

import RelatedReportsSection from "@/components/reports/RelatedReportsSection";
import { AvailableBadge, ComingSoonBadge, UnreleasedBadge } from "@/components/reports/Badges";
import { COMING_SOON } from "@/core/constants";

import { CUSTOMER_RELATED_REPORTS_LIST_QUERY, USER_ENTITLEMENTS_QUERY } from "../reports/graphql/queries";

const DESCRIPTION =
  "This test has biomarkers that are featured within the below reports. These reports are available to purchase and give a holistic view of your body's function. Uniquely combining DNA & functional markers.";

function getReportCardState({ report }) {
  const isComingSoon = report?.purchaseProduct?.status === COMING_SOON;

  let topRightButton = null;
  if (isComingSoon) {
    topRightButton = <ComingSoonBadge />;
  } else if (!report.isAvailable) {
    topRightButton = <UnreleasedBadge />;
  } else {
    topRightButton = <AvailableBadge />;
  }

  return {
    isComingSoon,
    isClickable: !isComingSoon && report.isAvailable,
    topRightButton
  };
}

export default function CustomerRelatedReportsSection({ userTest }) {
  const history = useHistory();

  return (
    <RelatedReportsSection
      userTest={userTest}
      reportsQuery={CUSTOMER_RELATED_REPORTS_LIST_QUERY}
      reportsQueryVariables={{
        userTestId: userTest.id
      }}
      entitlementsQuery={USER_ENTITLEMENTS_QUERY}
      requireReportEntitlement
      description={DESCRIPTION}
      getReportCardState={getReportCardState}
      onReportClick={report => {
        history.push(`/reports/${report.slug}/overview`);
      }}
    />
  );
}
